import React, { useState } from 'react'
import Button from '../../../components/CustomButtons/ButtonTS';
import CardBody from '../../../components/Card/CardBody';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { InputAdornment } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { SENSORS } from '../../helpers/Devices';

interface IBaseNodeCardBodyProps {
    baseAngle: number;
    baseDistance: number;
    measuredDistance: number;
    measuredAngle: number;
    lastMeasurementTimestamp: number;
    mainSensorType: string;
    nodeName: string;
    nodeID: number;
    isEditing: boolean;
    updatedViaWebsiteAt: string;
    hideAlert: () => void;
}

export default function BaseNodeCardBody(props: IBaseNodeCardBodyProps) {
    const fmtDate = (date?: number) => {
        if (!date) {
            return "No previous measurements, yet."
        }
        const d = (date).toString().split("T")[0];
        const t = (date).toString().split("T")[1].split("Z")[0].split(".")[0];
        return `${d} ${t}`;
    }

    const unit = (mainSensorType: string) => {
        return (mainSensorType === SENSORS.Iclinometer) ? "°" : "mm";
    }

    const getBaseValue = (baseAngle: number, baseDistance: number, mainSensorType: string) => {
        if (mainSensorType === SENSORS.Iclinometer) {
            return baseAngle;
        }
        return baseDistance;
    }

    const getMeasuredValue = (measuredAngle: number, measuredDistance: number, mainSensorType: string) => {
        if (mainSensorType === SENSORS.Iclinometer) {
            return measuredAngle;
        }
        return measuredDistance;
    }

    const validate = (base: string, sensor: string) => {
        const newBase = base.replace(/,/, '.');
        if (sensor === SENSORS.Iclinometer) {
            if (!newBase || !/^-?\d*\.?\d{0,3}$/.test(newBase) || parseFloat(newBase) > 4 || parseFloat(newBase) < -4) {
                setError(true);
            } else {
                setError(false);
            }
        }

        if (sensor === SENSORS.Laser) {
            if (!newBase || !/^\d+$/.test(newBase) || parseInt(newBase) > 40000 || parseInt(newBase) < 0) {
                setError(true);
            } else {
                setError(false);
            }
        }
        setNewBase(newBase)
    }

    const {
        isEditing,
        baseAngle,
        measuredDistance,
        measuredAngle,
        baseDistance,
        mainSensorType,
        nodeID,
        updatedViaWebsiteAt,
        baseAndWaitForRecalc,
        systemID,
        nodeName,
        hideAlert
    } = props;
    const base = getBaseValue(baseAngle, baseDistance, mainSensorType);
    const measuredValue = getMeasuredValue(measuredAngle, measuredDistance, mainSensorType);
    const [blockButton, setBlockButton] = useState(false);
    const [newBase, setNewBase] = useState(measuredValue != null ? '' + measuredValue : '');
    const [error, setError] = useState(false);
//     const lastMeasurementTimestamp = fmtDate(props.lastMeasurementTimestamp);
    const units = unit(mainSensorType);
    const utils = { defaultMaxInputLength: 12 }
    return (
        <CardBody>
            <form>
                <GridContainer style={{ margin: '0 0 0 -15px' }}>
                    <GridItem xs={12} style={{ margin: '25px 0 0 0' }}>
{/*                         <p> */}
{/*                             Measured at: {lastMeasurementTimestamp} */}
{/*                         </p> */}
                        {base === null && measuredValue === null
                            ? <>
                            <p>No previous measurements, yet.</p>
                            <p>Please enter base value: </p>
                            </>
                            : null}
                        <TextField
                            id='name'
                            error={error}
                            inputProps={{
                                value: newBase,
                                maxLength: utils.defaultMaxInputLength,
                                autoCapitalize: 'off',
                            }}
                            InputProps={{
                                endAdornment: <InputAdornment position="start">{units}</InputAdornment>,
                            }}
                            onChange={(e) => {
                                const { value } = e.target;
                                validate(value, mainSensorType);
                            }}
                            onKeyDown={(e) => {
                                const key = e.key;
                                const value = e.target.value;
                                let allowedChars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 
                                            "Backspace", "Delete", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"];
                                if (mainSensorType === SENSORS.Iclinometer) {
                                    if (!value.length) {
                                        allowedChars.push('-');
                                    }
                                    if (value.indexOf(".") < 0 && value.length > 0 && value != "-")  {
                                        allowedChars.push('.');
                                        allowedChars.push(',');
                                    }
                                    if (/[,.][0-9]{3}/.test(value)) {
                                        allowedChars.splice(0, 10);
                                    }
                                }
                                if (allowedChars.indexOf(key) < 0) {
                                    e.preventDefault();
                                }
                            }}
                            style={{ marginTop: '15px', width: '70%' }}
                            helperText={error ? 'Invalid value' : 'Numeric values only'}
                            className={error ? 'showAnimation' : ''}
                        ></TextField>
                    </GridItem>
                    <GridItem xs={12} style={{ margin: '25px 0 0 0' }}>
                        <Button
                            color='info'
                            onClick={(e, value) => {
                                if (parseFloat(newBase) !== base) {
                                    setBlockButton(true);
                                    baseAndWaitForRecalc(nodeID, parseFloat(newBase), updatedViaWebsiteAt, systemID, nodeName);
                                    hideAlert();
                                }
                            }}
                            disabled={blockButton || error || isEditing}
                            data-testid='downloadButton'
                            className='downloadButton' >
                            Base
                        </Button>
                    </GridItem>
                </GridContainer>
            </form>
        </CardBody >
    )
}
